const KEY = 'PARTNER';

export { KEY };
